import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import { DefaultContainer } from '@/components/atoms/Containers/styles';

export const Container = styled(DefaultContainer)`
  background-color: ${({ theme }) => theme.colors.bg.primary};
  min-height: 55vh;
  padding: 2rem 0;
  position: relative;

  .absolute-btn {
    bottom: 10%;
    position: absolute;
    z-index: 9;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 6rem 0 0;

    .absolute-btn {
      bottom: 8%;
    }
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  height: 100%;
  justify-content: center;
  max-width: 1070px;
  padding: 0 1rem;
  text-align: center;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: start;
    flex-direction: row;
    gap: 2rem;
    height: 100%;
    justify-content: space-between;
    text-align: left;
  }
`;

export const TextWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  svg {
    margin-bottom: 10px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: start;
    width: 28%;

    .section-title {
      max-width: 340px;
    }
  }
`;

export const SectionImage = styled.img`
  max-width: 550px;
  width: 100%;
`;

export const SwiperWrapper = styled(Swiper)`
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: 1070px;
  padding: 45px 0 0;
  position: relative;
  margin: 4rem 0 0rem;
  width: 100%;
  flex-direction: row;
  height: 400px;

  .swiper-pagination-bullet {
    background-color: white;
    width: 30px;
    height: 5px;
    border-radius: 10px;
    border: solid 1px ${({ theme }) => theme.colors.bg.carrouselBullet};
    opacity: 0.9;
    margin-right: -1px !important;
  }

  .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.colors.bg.carrouselBullet};
  }

  .slideNextClass {
    background-color: red;
    width: 50px;
    height: 50px;
  }

  .swiper-btn-prev,
  .swiper-btn-next {
    background-color: ${({ theme }) => theme.colors.vpag};
    border: 1px solid ${({ theme }) => theme.colors.vpag};
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.info.dark};
    cursor: pointer;
    font-size: 25px;
    height: 36px;
    left: 20px;
    opacity: 1;
    padding: 5px;
    position: absolute;
    top: 0;
    width: 36px;
    z-index: 11;
  }

  .swiper-btn-next {
    left: 60px;
  }

  .swiper-btn-prev.swiper-button-disabled,
  .swiper-btn-next.swiper-button-disabled {
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.info.dark};
  }

  .swiper-button-lock {
    display: none;
  }
`;
